import { useQuery } from '@tanstack/react-query';
import { queryKeys } from '@/lib/queryKeys';
import { lossRecordService } from '@/services/lossRecordService';
import { useAuth } from '@/hooks/useAuth';

export const useLossRecordList = () => {
  const { isAuthenticated } = useAuth();

  return useQuery({
    queryKey: queryKeys.lossRecord.list(),
    queryFn: () => lossRecordService.list(),
    staleTime: 30_000,
    enabled: isAuthenticated,
  });
};
